import React from 'react'
import styles from './Accordion.scss'
import {Set} from 'immutable'
import {Icon} from 'common/Icon'
import cx from 'classnames'

// "smart" accordion that handles its own internal state.
// Note that if you use this, you CANNOT control the state
// of the accordion from the outside. If you need to
// control the state of the accordion from outside,
// use an <AccordionWrapper> and manage the `expanded`
// and onToggle prop of each <AccordionItem> yourself.
//
// Important caveats:
// - Accordion items must have a title
// - Accordion item titles must be unique
export class Accordion extends React.PureComponent {
  constructor (props) {
    super(props)
    const defaultExpanded = React.Children.toArray(props.children)
      .filter(c => c.props.defaultExpanded)
      .map(c => c.props.title)
    this.state = {
      expanded: Set(defaultExpanded)
    }
  }

  toggleItem = (item) => {
    const {expanded} = this.state
    const {multi} = this.props
    if (multi) {
      this.setState({
        expanded: expanded.has(item) ? expanded.remove(item) : expanded.add(item)
      })
    } else {
      this.setState({
        expanded: expanded.has(item) ? Set() : Set([item])
      })
    }
  }

  render () {
    const {children} = this.props
    const {expanded} = this.state
    return (
      <AccordionWrapper>
        {React.Children.map(children, c =>
          React.cloneElement(c, {expanded, toggleItem: this.toggleItem})
        )}
      </AccordionWrapper>
    )
  }
}

export const AccordionWrapper = (props) => (
  <div className={styles.Accordion} {...props} />
)

export class AccordionItem extends React.PureComponent {
  constructor (props) {
    super(props)
    // id is initialized to a hash of the initial title and kept that way.
    // this prevents items from collapsing when the title changes
    this._id = props.title
  }

  onClickTitle = () => {
    console.log('toggling', this._id)
    this.props.toggleItem(this._id)
  }

  render () {
    const {expanded, title, children} = this.props
    const isExpanded = expanded.has(this._id)
    return (
      <div className={styles.AccordionItem}>
        <div className={styles.titleBar} onClick={this.onClickTitle}>
          <h3>{title}</h3><Icon i='chevron-centered' size={18} className={cx(styles.expandIcon, isExpanded && styles.expanded)} />
        </div>
        {isExpanded && <div className={styles.content}>
          {children}
        </div>}
      </div>
    )
  }
}
